import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import { generatePhoneTemplateHref } from '@perpay-web/fintech/utils/routeUtils';

import { CTA_DISPLAY_PHONE_NUMBER, CTA_PHONE_NUMBER } from './CtaPhoneNumber';
import styles from './IdentityVerificationRequired.scss';
import IdentityVerificationTemplate from './IdentityVerificationTemplate';

const IdentityVerificationInitial = () => {
    const copyContent = (
        <p className={styles.copy}>
            It looks like you&apos;ve put an alert on your credit file.
            It&apos;s great that you&apos;re taking steps to protect yourself
            from fraud, but because of this alert,{' '}
            <b>you&apos;ll need to give us a call to verify your identity</b>{' '}
            before we can proceed with your application. You have <b>30 days</b>{' '}
            to do so before we close your application.
        </p>
    );

    return (
        <IdentityVerificationTemplate
            copyContent={copyContent}
            footerContent={
                <CardCta
                    action='primary'
                    Component={CustomLink}
                    className={styles['footer-button']}
                    href={generatePhoneTemplateHref(CTA_PHONE_NUMBER)}
                >
                    Call us at {CTA_DISPLAY_PHONE_NUMBER}
                </CardCta>
            }
        />
    );
};

export default IdentityVerificationInitial;
